export const DEFAULT_FILTERS = {
  isVoid: 'false',
};
